// components/EventSummary/PastEventBanner.js

import React from 'react';
import styled from 'styled-components';
import Typography from '../Typography';
import { theme } from '../../theme';
import { useTranslation } from 'react-i18next';
import { getTimeSinceEventPassed } from '../../utils/dateUtils';
import CalendarSolidIcon from '../Icons/CalendarSolidIcon';

const BannerContainer = styled.div`
  border-radius: ${props => props.$borderRadius || props.theme.sizing.sm};
  // border: 1px solid ${({ theme }) => theme.border.defaultWeak};
  // border: ${props => props.$borderWidth || '1px'} solid ${({ theme }) => theme.border.defaultWeak};
  border-left: ${props => props.$borderLeft || '1px'} solid ${props => props.$borderColor || theme.border.defaultWeak};
  border-right: ${props => props.$borderRight || '1px'} solid ${props => props.$borderColor || theme.border.defaultWeak};
  border-top: ${props => props.$borderTop || '1px'} solid ${props => props.$borderColor || theme.border.defaultWeak};
  border-bottom: ${props => props.$borderBottom || '1px'} solid ${props => props.$borderColor || theme.border.defaultWeak};
  background-color: ${({ theme }) => theme.fill.defaultSubtle};
  padding: ${({ theme }) => theme.sizing.sm};
  width: ${props => props.$width || 'auto'};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.sm};
`;

const CalendarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 52px;
  background: ${({ theme }) => theme.fill.defaultWeak};
  border-radius: ${({ theme }) => theme.radius.xs};
  flex-shrink: 0;
`;

const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const PastEventBanner = ({ eventEndDate, hideIcon = false, borderRadius, width = "auto", borderWidth = "1px", borderLeft = "1px", borderRight = "1px", borderTop = "1px", borderBottom = "1px", borderColor = theme.border.defaultWeak }) => {
  const { t, i18n } = useTranslation('eventDetail');
  const timeSinceEvent = getTimeSinceEventPassed(eventEndDate, i18n.language);

  return (
    <BannerContainer $borderRadius={borderRadius} $width={width} $borderWidth={borderWidth} $borderLeft={borderLeft} $borderRight={borderRight} $borderTop={borderTop} $borderBottom={borderBottom} $borderColor={borderColor}>
      {!hideIcon && (
        <CalendarContainer>
          <CalendarSolidIcon fill={theme.colors.defaultStrong} width="20" height="20" />
        </CalendarContainer>
      )}

      <BannerContent>
        <Typography
          $variant="body-1-semibold"
          as="p"
          color={theme.colors.defaultStrong}
        >
          {t('eventSummary.pastEvent')}
        </Typography>
        <Typography
          $variant="body-2-medium"
          as="p"
          color={theme.colors.defaultWeak}
        >
          {t('eventSummary.timePast', { timeSinceEvent })}
        </Typography>
      </BannerContent>
    </BannerContainer>
  );
};

export default PastEventBanner;